// Taking into account our header, scrolls an element into view.
const scrollIntoViewWithHeader = element => {
  const mainNav = document.getElementsByTagName('header')[0];
  const yOffset = -mainNav.offsetHeight;
  const scrollToPosition =
    element.getBoundingClientRect().top + window.pageYOffset + yOffset;

  window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
};

export default scrollIntoViewWithHeader;
